import React from 'react';

import ConsentDetails from '@components/CookieBanner/shared/ConsentDetails';
import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';

const buildDetailList = (
  descriptionKey,
  description,
  consentIdKey,
  consentId,
  consentDateKey,
  consentDate
) => [
  { title: descriptionKey, value: description },
  { title: consentIdKey, value: consentId },
  { title: consentDateKey, value: consentDate }
];

interface PanelCookieBannerProps {
  title: string;
  descriptionLabel: string;
  description: string;
  consentIdLabel: string;
  consentId: string;
  consentDateLabel: string;
  consentDate?: string;
}

const PanelCookieBanner = ({
  title: cookieConsentTitle,
  descriptionLabel,
  description,
  consentIdLabel,
  consentId,
  consentDateLabel,
  consentDate = new Date().toISOString()
}: PanelCookieBannerProps) => {
  const details = buildDetailList(
    descriptionLabel,
    description,
    consentIdLabel,
    consentId,
    consentDateLabel,
    consentDate
  );

  return (
    <CookieBannerPanel.Root>
      <CookieBannerPanel.Title>{cookieConsentTitle}</CookieBannerPanel.Title>
      <CookieBannerPanel.Description>
        {details.map(({ title, value }) => (
          <ConsentDetails key={title} title={title} value={value} />
        ))}
      </CookieBannerPanel.Description>
    </CookieBannerPanel.Root>
  );
};

export default PanelCookieBanner;
